import React from 'react';
import styles from './ExpandableTextarea.module.css';
import TextareaAutosize from 'react-textarea-autosize';
import { ReactComponent as CloseIcon } from '../../../assets/images/close.svg';
import classNames from 'classnames';

const ExpandableTextarea = ({ placeholder, value, maxLength = '250', onChange, id = 'description', ...props }) => {
    return (
        <div className={styles.expandableTextarea}>
            <TextareaAutosize
                onChange={onChange}
                value={value}
                placeholder={placeholder || 'Enter Description'}
                className={classNames('form-control', styles.formControlTextarea)}
                maxLength={maxLength}
                id={id}
            />
            <div className={styles.charCount}>
                {value.length}/{maxLength}
            </div>
            {value.length > 0 && (
                <span
                    type='button'
                    onClick={() => onChange({ target: { value: '' } })}
                    className={styles.emptyTextArea}
                >
                    <CloseIcon />
                </span>
            )}
        </div>
    );
};

export default ExpandableTextarea;
